import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tvOption: false,
    mobileOption: false,
  },
  mutations: {
    TOGGLE_MOBILE(state, params) {
      state.mobileOption = params
    },
    TOGGLE_TV(state, params) {
      state.tvOption = params
    }
  },
  actions: {
    toggleMobileOption({ commit }, params) {
      commit('TOGGLE_MOBILE', params)
    },
    toggleTvOption({ commit }, params) {
      commit('TOGGLE_TV', params)
    },
    resetState({commit}) {
      commit('TOGGLE_MOBILE', false)
      commit('TOGGLE_TV', false)
    }
  }
})
